import * as React from "react";
import { casesActions } from "configs";
import { useDispatch, useOnline } from "duck";
import { MedicalCasesDocument, useDeleteMedicalCasesMutation } from "requests";
import { hooks, SelectionContext } from "../../../../../../../duck";

export const useDelete = () => {
  const online = useOnline();
  const dispatch = useDispatch();
  const { selection, reset } = React.useContext(SelectionContext);

  const [deleteCases] = useDeleteMedicalCasesMutation();
  const variables = hooks.useListQueryVariables();

  return {
    onConfirm: () => {
      const onlineIds = selection
        .filter(medCase => medCase.offlineStatus === "normal")
        .map(medCase => medCase._id);

      dispatch(casesActions.deleteCases(selection.map(medCase => medCase._id)));

      const onlinePromise =
        onlineIds.length > 0 && online
          ? deleteCases({
              variables: { input: { ids: onlineIds } },
              refetchQueries: [{ query: MedicalCasesDocument, variables }],
              awaitRefetchQueries: true
            }).then(() => {})
          : Promise.resolve();

      return Promise.all([onlinePromise]).then(() => {
        reset();
      });
    },
    names: selection.map(medCase => medCase.name)
  };
};
